<template>
    <div class="mt-8 py-2">
        <div @click="close()" class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100">
            <span class="material-symbols-outlined notranslate fill-current">
                <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold mb-1 pb-2 mx-2">{{ trans.search_box.search }}</div>
            <div class="btn btn-sm rounded-full normal-case" @click="clearAllFilter">
                {{ trans.search_box.all_clear }}
            </div>
        </div>
        <div class="mx-4">
            <div class="mt-3 my-2">
                <div class="relative w-full">
                    <div class="absolute z-10 my-2 ml-2 text-base-content opacity-60">
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                        </span>
                    </div>
                    <div class="absolute z-10 right-0 mt-2 mr-2 text-base-content opacity-60" v-if="search.length > 0" @click="clearSearchInput(), isShowSuggestions = false">
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                        </span>
                    </div>
                    <input
                        type="text"
                        name="search"
                        autocomplete="off"
                        placeholder="Search…"
                        class="input w-full input-sm h-10 input-bordered input-ml"
                        v-model.trim="search"
                        @focus="isShowSuggestions = true"
                        @keyup.delete="isShowSuggestions = true"
                        @input="handleSearchInput"
                    />
                </div>
            </div>

            <div class="results" v-if="isShowSuggestions && suggestions.length > 0">
                <div class="flex justify-between">
                    <div class="text-sm font-bold mt-2 pl-2 ml-4 text-base-content text-opacity-50">
                        {{ trans.search_box.keyword }}
                    </div>
                    <div class="btn btn-sm btn-link" @click="isShowSuggestions = false">
                        {{ trans.search_box.close }}
                    </div>
                </div>
                <div class="overflow-y-auto h-screen search-content-height">
                    <table class="table">
                        <tbody>
                            <tr
                                class="hover"
                                :class="{
                                    highlight: isHighlightClass && index == hoverSuggestion
                                }"
                                v-for="(suggestion, index) in suggestions"
                                :key="'search-suggestion' + index"
                                @mousedown="chooseSuggestion(suggestion)"
                                @mouseover="
                                    hoverSuggestion = index;
                                    isHighlightClass = true;
                                "
                                @mouseleave="isHighlightClass = false"
                                style="border-bottom-style: solid"
                            >
                                <td>
                                    <div class="flex items-center gap-3">
                                        <span class="material-symbols-outlined notranslate fill-current">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                                        </span>
                                        <div
                                            class="text-base-content text-sm break-words"
                                            style="overflow-wrap: anywhere"
                                        >
                                            {{ suggestion }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="text-center mt-2 mx-4" v-if="suggestions.length >= 20">
                        <div class="font-bold mb-2">{{ trans.search_box.show_maximum }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overflow-y-auto h-screen search-content-height">
            <div class="mx-4">
                <div class="mb-96 sm:mb-20 pb-48">
                    <div class="" v-if="categoryData.length > 0">
                        <form name="sampleform">
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.category }}</span>
                                </li>
                                <li
                                    v-for="category in categoryData"
                                    :key="'search-cate-' + category.id"
                                >
                                    <label class="label cursor-pointer">
                                        <span class="label-text">{{ category.title }}</span>
                                        <input
                                            type="checkbox"
                                            class="checkbox checkbox-primary"
                                            :value="category.id"
                                            v-model="filter.categories"
                                        />
                                    </label>
                                </li>
                            </ul>
                            <p class="allcheck my-2 justify-end card-actions justify-end">
                                <input
                                    type="button"
                                    :value="trans.search_box.select_all"
                                    @click="allCheckCategories(true)"
                                />
                                <input
                                    type="button"
                                    :value="trans.search_box.clear"
                                    @click="allCheckCategories(false)"
                                />
                            </p>
                        </form>
                        <div class="divider my-1"></div>
                    </div>
                    <div class="" v-if="itemResource.length > 0">
                        <form name="sampleform">
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.item }}</span>
                                </li>
                                <li v-for="item in itemResource" :key="'search-item-' + item.id">
                                    <label class="label cursor-pointer">
                                        <span class="label-text">{{ item.title }}</span>
                                        <input
                                            type="radio"
                                            class="radio radio-primary"
                                            :value="item.id"
                                            v-model="filter.item"
                                        />
                                    </label>
                                </li>
                            </ul>
                            <p class="allcheck my-2 justify-end card-actions justify-end">
                                <input
                                    type="button"
                                    :value="trans.search_box.clear"
                                    @click="filter.item = ''"
                                />
                            </p>
                        </form>
                        <div class="divider my-1"></div>
                    </div>
                    <div class="" v-if="facilityResource.length > 0">
                        <form name="sampleform">
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.facility }}</span>
                                </li>
                                <li
                                    v-for="facility in facilityResource"
                                    :key="'search-facility-' + facility.id"
                                >
                                    <label class="label cursor-pointer">
                                        <span class="label-text">{{ facility.title }}</span>
                                        <input
                                            type="checkbox"
                                            class="checkbox checkbox-primary"
                                            :value="facility.id"
                                            v-model="filter.facilities"
                                        />
                                    </label>
                                </li>
                            </ul>
                            <p class="allcheck my-2 justify-end card-actions justify-end">
                                <input
                                    type="button"
                                    :value="trans.search_box.clear"
                                    @click="filter.facilities = []"
                                />
                            </p>
                        </form>
                        <div class="divider my-1"></div>
                    </div>
                    <div class="" v-if="sortedAreas.length > 0">
                        <form name="sampleform">
                            <ul class="menu overflow-visible">
                                <li class="menu-title">
                                    <span>{{ trans.search_box.area }}</span>
                                </li>
                                <li v-for="areaT1 in sortedAreas" :key="'search-area-' + areaT1.id">
                                    <label class="label cursor-pointer" for="">
                                        <span class="label-text">
                                            <span
                                                v-show="areaT1.children"
                                                class="fas"
                                                @click="toggleTreeView(areaT1.id)"
                                                :class="
                                                    treeView['child_of_' + areaT1.id]
                                                        ? 'fa-minus-square'
                                                        : 'fa-plus-square'
                                                "
                                                >&nbsp;</span
                                            >{{ areaT1.title }}</span
                                        >
                                        <input
                                            type="checkbox"
                                            class="checkbox checkbox-primary"
                                            :value="areaT1.id"
                                            v-model="filter.areas"
                                            @change="checkClickAllAreas(areaT1, $event)"
                                        />
                                    </label>
                                    <ul
                                        class="block static left-0 ml-2"
                                        v-show="
                                            areaT1.children && treeView['child_of_' + areaT1.id]
                                        "
                                    >
                                        <li
                                            v-for="areaT2 in areaT1.children"
                                            :key="'search-area-' + areaT2.id"
                                        >
                                            <label
                                                class="label cursor-pointer whitespace-pre-line"
                                                for=""
                                            >
                                                <span class="label-text">
                                                    <span
                                                        v-show="areaT2.children"
                                                        class="fas"
                                                        @click="toggleTreeView(areaT2.id)"
                                                        :class="
                                                            treeView['child_of_' + areaT2.id]
                                                                ? 'fa-minus-square'
                                                                : 'fa-plus-square'
                                                        "
                                                        >&nbsp;</span
                                                    >{{ areaT2.title }}</span
                                                >
                                                <input
                                                    type="checkbox"
                                                    class="checkbox checkbox-primary"
                                                    :value="areaT2.id"
                                                    v-model="filter.areas"
                                                    @change="checkClickAllAreas(areaT2, $event)"
                                                />
                                            </label>
                                            <ul
                                                class="pl-0 ml-2"
                                                v-show="
                                                    areaT2.children &&
                                                    treeView['child_of_' + areaT2.id]
                                                "
                                            >
                                                <li
                                                    v-for="areaT3 in areaT2.children"
                                                    :key="'search-area-' + areaT3.id"
                                                >
                                                    <label
                                                        class="label cursor-pointer whitespace-pre-line"
                                                        for=""
                                                    >
                                                        <span class="label-text">{{
                                                            areaT3.title
                                                        }}</span>
                                                        <input
                                                            type="checkbox"
                                                            class="checkbox checkbox-primary"
                                                            :value="areaT3.id"
                                                            v-model="filter.areas"
                                                        />
                                                    </label>
                                                </li>
                                            </ul>
                                            <!-- level3 -->
                                        </li>
                                    </ul>
                                    <!-- level2 -->
                                </li>
                            </ul>
                            <!-- level1 -->
                            <p class="allcheck my-2 justify-end card-actions justify-end">
                                <input
                                    type="button"
                                    :value="trans.search_box.clear"
                                    @click="filter.areas = []"
                                />
                            </p>
                        </form>
                    </div>
                    <div class="">
                        <div class="grid grid-cols-1 gap-2">
                            <button
                                class="absolute inset-x-0 bottom-12 btn mx-3 normal-case z-20 drop-shadow-lg button-position"
                                :class="{ 'btn-primary': numberOfResult > 0 }"
                                v-on="numberOfResult <= 100 ? { click: clickLocationsFound } : {}"
                            >
                                <div class="badge ml-1" v-if="numberOfResult <= 100">{{ numberOfResult }}</div>
                                <span>{{ numberOfResult <= 100 ? trans.search_box.found_results : trans.search_box.large_results }}</span>
                            </button>
                            <button class="btn btn-link btn-block" @click="close()">
                                {{ trans.search_box.show_map }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    inject: ['trans'],
    props: {
        locationResource: {
            type: Array,
            required: true
        },
        itemResource: {
            type: Array,
            required: true
        },
        facilityResource: {
            type: Array,
            required: true
        },
        areaResource: {
            type: Array,
            required: true
        },
        searchableAreaIds: {
            type: Array,
            default: function () {
                return [];
            }
        },
        categoryData: {
            type: Array,
            required: true
        },
        numberOfResult: {
            type: Number
        },
        currentTag: {
            type: String
        }
    },
    data() {
        return {
            search: '',
            suggestions: [],
            hoverSuggestion: '',
            isHighlightClass: false,
            isShowSuggestions: false,
            filter: {
                keyword: '',
                categories: [],
                item: '',
                facilities: [],
                areas: []
            },
            sortedAreas: [],
            treeView: {}
        };
    },
    computed: {
        titlesAndTags() {
            let results = [];
            this.locationResource.forEach((element) => {
                const properties = element.properties;
                let found = results.find((element) => element.name == properties.name);
                if (!found) {
                    results.push({ id: properties.id, name: properties.title });
                }
                properties.tags.forEach((tag) => {
                    let found = results.find((element) => element.name == tag);
                    if (!found) {
                        results.push({ id: properties.id, name: tag });
                    }
                });
            });

            return results.sort(function (a, b) {
                var nameA = a.name.toUpperCase();
                var nameB = b.name.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            });
        }
    },
    methods: {
        close() {
            this.$emit('closed');
        },
        showLocationsList() {
            this.$emit('showedLocationsList');
        },
        chooseSuggestion(payload) {
            this.triggerEventGA('searched_keyword', {
                id: payload,
                title: payload
            });
            this.search = payload;
            this.isShowSuggestions = false;
        },
        allCheckCategories(type) {
            if (type) {
                this.filter.categories = [];
                this.categoryData.forEach((item) => {
                    this.filter.categories.push(item.id);
                });
            } else {
                this.filter.categories = [];
            }
        },
        generateSortedAreas() {
            if (this.areaResource.length == 0 || this.searchableAreaIds.length == 0) {
                return [];
            }
            var wideAreas = [];
            var middleAreas = [];
            var narrowAreas = [];
            var childrenOfAreas = {};
            var areaLevel = 1;
            var searchableAreas = this.areaResource.filter((el) =>
                this.searchableAreaIds.includes(el.id)
            );
            searchableAreas.forEach((area) => {
                areaLevel = area.type > areaLevel ? area.type : areaLevel;
                const upperAreaId = area.upper_area_id;
                if (upperAreaId && upperAreaId in childrenOfAreas != true) {
                    childrenOfAreas[upperAreaId] = [];
                }
                if (upperAreaId) {
                    childrenOfAreas[upperAreaId].push(area);
                }
                switch (area.type) {
                    case 1:
                        narrowAreas.push(area);
                        break;
                    case 2:
                        middleAreas.push(area);
                        this.$set(this.treeView, 'child_of_' + area.id, false);
                        break;
                    default:
                        wideAreas.push(area);
                        this.$set(this.treeView, 'child_of_' + area.id, false);
                        break;
                }
            });

            if (areaLevel == 1) return narrowAreas;

            middleAreas.forEach((area) => {
                area.children = childrenOfAreas[area.id];
            });
            if (areaLevel == 2) {
                return middleAreas;
            }

            wideAreas.forEach((area) => {
                area.children = childrenOfAreas[area.id];
            });
            return wideAreas;
        },
        toggleTreeView(payload) {
            this.treeView['child_of_' + payload] = !this.treeView['child_of_' + payload];
        },
        checkClickAllAreas(area, event) {
            if (!area.children || area.type == 1) return;

            area.children.forEach((child) => {
                const indexOf = this.filter.areas.indexOf(child.id);
                if (indexOf == -1 && event.target.checked) {
                    this.filter.areas.push(child.id);
                }
                if (indexOf != -1 && !event.target.checked) {
                    this.filter.areas.splice(indexOf, 1);
                }
                if (child.type == 2) {
                    this.checkClickAllAreas(child, event);
                }
            });
        },
        clearAllFilter() {
            this.allCheckCategories(false);
            this.filter = {
                keyword: '',
                categories: [],
                item: '',
                facilities: [],
                areas: []
            };
            this.search = '';
        },
        clearSearchInput() {
            this.search = '';
        },
        clickLocationsFound() {
            this.$emit('toggledSubSidebar', 'locationListBox');
            this.$emit('isClickedLocationsFound', true);
        },
        handleSearchInput() {
            if (this.search === '') {
                this.resetSuggestions();
            }
        },
        resetSuggestions() {
            this.suggestions = [];
        }
    },
    created() {
        this.sortedAreas = this.generateSortedAreas();
    },
    mounted() {},
    watch: {
        search(newVal) {
            var invalid = /[^a-zA-Z0-9\s]+/g;
            var sanitizedNewval = newVal.replace(invalid, '\\$&');
            this.filter.keyword = sanitizedNewval;
            if (!newVal || !this.isShowSuggestions) return;

            let results = [];
            const pattern = new RegExp(`${sanitizedNewval}`, 'i');
            let total = this.titlesAndTags.length;
            let n = 0;
            for (let i = 0; i < total; i++) {
                if (n >= 20) break;
                const item = this.titlesAndTags[i].name;
                if (item.search(pattern) != -1) {
                    results.push(item);
                    n++;
                }
            }
            this.suggestions = results;
        },
        filter: {
            handler: function (newVal) {
                this.$emit('filtered', newVal);
            },
            deep: true
        },
        currentTag(newVal) {
            this.search = newVal;
            this.$emit('toggledSubSidebar', 'searchBox');
        }
    }
};
</script>

<style>
.input-ml {
    padding-left: 34px;
    padding-right: 34px;

}
.search-content-height {
    padding-bottom: 30rem;
}
.button-position {
    width: -moz-available;
}
@media screen and (max-width: 639px) {
    .search-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
    .button-position {
        position: static;
    }
}
</style>
